export class Locations {
    id: string;
    code: string;
    name: string;
    extendedName: string;
    description: string;
    typeUse: string;
    utm: string;
    lat: number;
    lng: number;
    altitude: number;
    companyId: number;
    parentLocationId: string;
    metadata: string;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;

    private spanishNames?: Record<string, string> = {
        id: "identificador",
        code: "código",
        name: "nombre",
        extendedName: "nombre extendido",
        description: "descripción",
        typeUse: "tipo de uso",
        utm: "coordenadas UTM",
        lat: "latitud",
        lng: "longitud",
        altitude: "altitud",
        companyId: "ID empresa",
        parentLocationId: "ID ubicación padre",
        metadata: "metadatos",
        createdAt: "creado en",
        updatedAt: "actualizado en",
        createdBy: "creado por",
        updatedBy: "actualizado por",
    };

    constructor(data?: Partial<Locations>) {
        this.id = data?.id ?? "";
        this.code = data?.code ?? "";
        this.name = data?.name ?? "";
        this.extendedName = data?.extendedName ?? "";
        this.description = data?.description ?? "";
        this.typeUse = data?.typeUse ?? "";
        this.utm = data?.utm ?? "";
        this.lat = data?.lat ?? 0;
        this.lng = data?.lng ?? 0;
        this.altitude = data?.altitude ?? 0;
        this.companyId = data?.companyId ?? 0;
        this.parentLocationId = data?.parentLocationId ?? "";
        this.metadata = data?.metadata ?? "";
        this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
        this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
        this.createdBy = data?.createdBy ?? "";
        this.updatedBy = data?.updatedBy ?? "";
    }

    getSpanishName(propertyName: string): string {
        if (this.spanishNames && this.spanishNames[propertyName]) {
            return this.spanishNames[propertyName];
        }
        return propertyName;
    }

    toPlainObject(): Record<string, any> {
        return {
            id: this.id,
            code: this.code,
            name: this.name,
            extendedName: this.extendedName,
            description: this.description,
            typeUse: this.typeUse,
            utm: this.utm,
            lat: this.lat,
            lng: this.lng,
            altitude: this.altitude,
            companyId: this.companyId,
            parentLocationId: this.parentLocationId,
            metadata: this.metadata,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            createdBy: this.createdBy,
            updatedBy: this.updatedBy,
        };
    }
}
